export default {"src":"/_next/static/media/automatic-update.7add300f.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};